import { useState } from 'react'
import { useLisReviewSummary } from '@/hooks/useLisReview'
import { formatPendingCount, LIS_PENDING_CLASS, pendingCount } from '@/lib/lisReview'
import { cn } from '@/lib/utils'
import { LisReviewListDialog } from './LisReviewListDialog'

/**
 * The orange LIS queue count on a Home tile (z8nrz7fcu4): every result in the
 * tenant waiting for approval. Clicking it opens the queue in place instead of
 * following the tile's link. Renders nothing while the queue is empty.
 */
export function LisQueueTileBadge({ label }: { label: string }) {
  const [open, setOpen] = useState(false)
  const { data } = useLisReviewSummary()
  const count = pendingCount(data)

  return (
    <>
      {count > 0 && (
        <button
          type='button'
          onClick={() => setOpen(true)}
          aria-label={`${count} LIS result${count === 1 ? '' : 's'} waiting for review. Open the queue from ${label}`}
          title={`${count} LIS result${count === 1 ? '' : 's'} waiting for review`}
          className={cn(
            'flex h-4 min-w-[16px] items-center justify-center rounded-full px-1 text-[10px] font-bold leading-none ring-2 ring-white hover:brightness-110',
            LIS_PENDING_CLASS,
          )}
        >
          {formatPendingCount(count)}
        </button>
      )}
      <LisReviewListDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
